import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var convertInMinutes = function convertInMinutes(hours) {
  return hours * 60;
};
export var calculateDifferenceInMinutes = function calculateDifferenceInMinutes(timestamp1, timestamp2) {
  var difference = (timestamp1 - timestamp2) / 1000;
  difference /= 60;
  return Math.round(difference);
};